<template>
  <div
    class="font-bold text-center text-2xl"
    :class="{
      'text-primary-0': isKids,
      'text-guardian-secondary-0': isGuardian,
      'text-pets-primary-1': isPets
    }"
  >
    <slot />
  </div>
</template>

<script setup>
import { isKids, isGuardian, isPets } from '@/comp/AppType'
</script>
